import _objectSpread from "@babel/runtime/helpers/objectSpread2";

/**
 * @module
 *
 * @description Education Loans driver configurations
 */
import { getDisclaimer, getFixedAprAnnotation, getMaxFixedAPR, getMaxVariableAPR, getMinFICO, getMinFixedAPR, getMinVariableAPR, getVariableAprAnnotation } from '../selectors/education-loans';
import { getPercentageRange } from '../utils/format';
import { VALUE_SIZES } from '../constants/drivers';
/**
 * Get the min. credit score driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverMinCreditScore = function getDriverMinCreditScore(offer) {
  return {
    id: 'minCreditScore',
    label: 'Min. credit score',
    value: getMinFICO(offer),
    valueSize: VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the fixed APR driver with HTML tooltip.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The disclaimer "quick fact" driver.
 */

export var getDriverFixedApr = function getDriverFixedApr(offer) {
  return {
    id: 'fixedAPR',
    label: 'Fixed APR',
    value: getPercentageRange(getMinFixedAPR(offer), getMaxFixedAPR(offer)),
    valueSize: VALUE_SIZES.MEDIUM,
    UNSAFE_valueTooltip: getDisclaimer(offer)
  };
};
/**
 * Get the fixed APR driver with annotation tooltip.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The annotation "quick fact" driver.
 */

export var getDriverFixedAprWithAnnotation = function getDriverFixedAprWithAnnotation(offer) {
  return _objectSpread(_objectSpread({}, getDriverFixedApr(offer)), {}, {
    UNSAFE_valueTooltip: getFixedAprAnnotation(offer)
  });
};
/**
 * Get the variable APR driver with HTML tooltip.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The disclaimer "quick fact" driver.
 */

export var getDriverVariableApr = function getDriverVariableApr(offer) {
  return {
    id: 'variableAPR',
    label: 'Variable APR',
    value: getPercentageRange(getMinVariableAPR(offer), getMaxVariableAPR(offer)),
    valueSize: VALUE_SIZES.MEDIUM,
    UNSAFE_valueTooltip: getDisclaimer(offer)
  };
};
/**
 * Get the fixed APR driver with annotation tooltip.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The annotation "quick fact" driver.
 */

export var getDriverVariableAprWithAnnotation = function getDriverVariableAprWithAnnotation(offer) {
  return _objectSpread(_objectSpread({}, getDriverVariableApr(offer)), {}, {
    UNSAFE_valueTooltip: getVariableAprAnnotation(offer)
  });
};